import { createContext } from "react"

const AlertsContext = createContext()

export default AlertsContext
